export default "<!-- Router outlets -->\n<router-outlet></router-outlet>"